import { api } from "../api";

export default async function markAsViewed(ids: number[]): Promise<number> {
  try {
    const { status } = await api.post("/stories/viewed", {
      ids,
    });

    return status;
  } catch (err) {
    throw err;
  }
}
